import { Component, Input, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { AbstractControlValueAccessorComponent } from '../../abstracts/abstract-control-value-accessor.component';
import { FormUtil } from '../../utils';

@Component({
    selector: 'px-textarea',
    templateUrl: './text-area.component.html',
    styleUrls: ['./text-area.component.scss'],
})
export class TextAreaComponent extends AbstractControlValueAccessorComponent implements ControlValueAccessor {
    @Input() maxLength = 3000;
    @Input() rows = 3;

    constructor(@Optional() @Self() public ngControl: NgControl) {
        super();
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }

    get formControl() {
        return this.ngControl ? this.ngControl.control : null;
    }

    get isRequired() {
        return this.formControl && FormUtil.hasValidatorKey(this.formControl, 'required');
    }

    get hasError() {
        return this.formControl && this.formControl.errors;
    }

    get hasErrorAndIsTouched() {
        return this.hasError && this.formControl.touched;
    }

    get errorMessage() {
        return FormUtil.getFirstError(this.formControl).replace('#LABEL', this.label ? this.label : 'Dieses Feld');
    }
}
